'use client'

import { useState, useEffect } from "react"
import SearchBar from "./SearchBar"
import Link from "next/link"
import SearchNav from "@/components/search/SearchNav"
import { useSearchParams, usePathname, useRouter } from "next/navigation"
import { useHandleSearchFromSearchBar } from "../search/useHandleSearchFromSearchBar"
import { useSearchBar } from "../search/useSearchBar"
import { createSearchPagePathname } from "@/services/pathname"

type SearchHeaderProps = {
    aroeven: Aroeven,
    object?: string
}

export default function SearchHeader({
    aroeven,
    object = 'none'
}: SearchHeaderProps) {

    const searchParams = useSearchParams()
    const pathname = usePathname()
    const { replace } = useRouter()

    const [search, setSearch] = useState(Object.fromEntries(new URLSearchParams(searchParams)))

    useEffect(() => {
        setSearch({
            //...search,
            ...Object.fromEntries(new URLSearchParams(searchParams))
        })
    }, [searchParams])

    const handleSearch = useHandleSearchFromSearchBar(search, 'search', 'sector', 'School')    

    return (
        <>
            <section className="navscroll d-none recherche pt-10 pb-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-xl-3 d-flex align-items-start" />
                        <div className="col-lg-12 col-xl-9">
                            <div className="tabs -underline">
                                <SearchBar
                                    search={search}
                                    setSearch={(search) => setSearch(search)}
                                    handleSearch={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="navhead recherche pt-40 pb-80 bg-bloc">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-xl-3 d-flex align-items-start">
                            <Link href={(['SchoolActivity', 'SchoolThematic', 'SchoolStay'].includes(object) === false ? '/recherche' : createSearchPagePathname('sector', 'School')) + ('query' in searchParams ? '?query=' + searchParams['query'] : '')} className="button-primary secteur d-block mt-80">
                                <i className="mr-15 fi fi-bs-cross-small" /> {{
                                    none: 'Prestations scolaires',
                                    SchoolActivity: 'Activités scolaires',
                                    SchoolThematic: 'Thématiques scolaires',
                                    SchoolStay: 'Séjours scolaires'
                                }[object] ?? 'Prestations scolaires'}
                            </Link>
                        </div>
                        <div className="col-lg-12 col-xl-9">
                            <div className="tabs -underline mt-80">
                                <SearchNav object={null} sector={'School'} />
                                <SearchBar
                                    search={search}
                                    setSearch={(search) => setSearch(search)}
                                    handleSearch={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}